import { render, staticRenderFns } from "./folder-tree.vue?vue&type=template&id=27db673c"
import script from "./folder-tree.vue?vue&type=script&lang=js"
export * from "./folder-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports